import http from "../../http-common";

class CafeteriaService {

    getAll(data) {
        return http.post("/admin/getCafeteria", data);
    }

    save(data) {
        return http.post("/admin/saveCafeteria", data);
    }

    delete(id) {
        return http.delete(`/admin/cafeteria/${id}`);
    }

}

export default new CafeteriaService();
